/**
 * OSM power lines, fences, walls, hedges and masts for the streamed tiles,
 * from Overpass, a block at a time, as the building tags are (see
 * `buildingTagService.ts` for the queueing, caching and cool-down).
 */

import type { OsmFeature } from '../core/sources/osmlines.js';
import { featuresWithin, overpassLineUrl, parseOverpassLines } from '../core/sources/osmlines.js';
import type { BuildingTagOptions } from './buildingTagService.js';
import { DEFAULT_BUILDING_TAG_OPTIONS, OverpassBlockService } from './buildingTagService.js';

export class OsmLineService extends OverpassBlockService<OsmFeature> {
  constructor(options: BuildingTagOptions = DEFAULT_BUILDING_TAG_OPTIONS) {
    super({
      url: overpassLineUrl,
      parse: parseOverpassLines,
      within: (features, bounds) => featuresWithin(features, bounds),
      count: (features) => features.length,
      cacheName: 'wsg-osm-lines-v1',
      contentType: 'application/json',
    }, options);
  }
}
